import React from "react"
import { FoundationLogo } from "./foundationLogo"
import { Signature } from "./signature"
import { VirtualReality } from "./virtualReality"
import { Scroll } from "./scroll"
import { ScrollTop } from "./scrollTop"
import { IVLogo } from "./ivLogo"

const Icon = ({ type, width, height, color }) => {
  switch (type) {
    case "foundation-logo":
      return <FoundationLogo width={width} height={height} color={color} />
    case "signature":
      return <Signature width={width} height={height} color={color} />
    case "vr":
      return <VirtualReality />
    case "scroll":
      return <Scroll />
    case "scrollTop":
      return <ScrollTop color={color} />
    case "ivLogo":
      return <IVLogo width={width} height={height} color={color}/>
    default:
      return null
  }
}

export { Icon }
